import Component from './Component'
import { Capitalize } from './utils'

export default {
  install(Vue, options = {}) {
    let { prefix = 'posts', router } = options

    router.addRoutes([
      { path: `/${prefix}/:slug`, name: Capitalize(prefix), component: Component, props: true },
    ])
  },
}
